import Vue from 'vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './routes/router'
import "./scss/_fontsMaterialIcons.scss";
import "./scss/_fontsRoboto.scss";
import Layout from "./layouts/Layout";
import "./filters";
import Moment from 'moment'

Vue.config.productionTip = false;


new Vue({
    vuetify,
    store,
    router,
    render: h => h(Layout),
    created() {
        Moment.locale('ru')
    },
}).$mount('#app');
